module.exports = __webpack_public_path__ + "img/italic.5c75cf30.svg";